<app-pagetitle title="{{nameApp}}" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

<div class="row">
    <div class="col-sm-12">
        <div class="card card-border">
            <div class="card-header">
                <div class="row">
                    <div class="col-sm-6 text-sm-right">
                        <button  *hasPermission="{app: constant.ROLES, permission: [constant.CREAR]}" type="button" class="btn btn-sm btn-success waves-effect" (click)="openModal()"><i class="fas fa-plus fa-lg mr-1"></i> Nuevo</button>
                    </div>
                </div>
            </div>

            <div class="container card-body table-responsive">
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped table-bordered row-border hover">
                    <thead>
                        <tr>
                            <th>Nro.</th>
                            <th>Nombre</th>
                            <th>Descripción</th>
                            <th>Estado</th>
                            <th>Acciones</th>.
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of dataApp; let indice=index">

                            <td>{{indice+1}}</td>
                            <td>{{row.nombre}}</td>
                            <td ><p class="text-justify">{{ ((row.descripcion.length < 70)? row.descripcion: row.descripcion.substring(0,67) + '. . .' )}}</p></td>
                            <td>{{((row.estado == '1')? 'Activo': 'Inactivo')}}</td>
                            <td class="text-center ">
                                <div class="row">
                                <button *hasPermission="{app: constant.ROLES, permission: [constant.ACTUALIZAR]}"  type="button" tooltip="Editar"
                                    class="btn btn-sm btn-link waves-effect rounded-pill col px-0"
                                    title="Editar este registro"
                                    (click)="edit(row)">
                                    <i class="fas fa-pencil-alt fa-lg"></i>
                                </button>
                                <button *hasPermission="{app: constant.ROLES, permission: [constant.BORRAR]}" type="button" class="btn btn-sm btn-link waves-effect col px-0"
                                title="Eliminar este registro"
                                (click)="delete(row.idSprRol)">
                                    <i class="fas fa-trash-alt fa-lg"></i>
                                </button>
                            </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<!-- MODAL PARA LA CONFIRMACION DEL BORRADO -->
<jw-modal id="delete-roles" [isDelete]="true" (confirmation)="confirmDelete()"></jw-modal>


<jw-modal id="{{nameModal}}">
    <!-- MODAL PARA CREAR Y EDITAR -->

        <div class="modal-dialog" style="padding-top:6%">
            <div class="modal-content">
                <div class="modal-header pb-3">
                    <h3 class="modal-title">{{nameApp}}</h3>
                    <button type="button" class="btn-close" (click)="modal.close();"
                        aria-label="Close"></button>
                </div>
                <div class="modal-body pT-4">
                    <form class="needs-validation" novalidate id="formRol" [formGroup]="formRol">

                        <div class="row">
                            <input type="hidden" id="idSprRol" formControlName="idSprRol">
                            <div class="form-floating mb-3">
                                <input id="idSprRol" type="text" class="form-control upperCase"  maxlength="50" required="true"
                                formControlName="nombre" [ngClass]="{
                                  'is-invalid': this.formRol.get('nombre')?.errors && this.submitted,
                                  'is-valid': !this.formRol.get('nombre')?.errors,
                                }" />
                              <small class="invalid-feedback"
                                *ngIf="this.formRol.get('nombre')?.errors?.['required'] && this.submitted">
                                    Campo requerido</small>
                                    <label for="idSprRol" class="col-form-label text-md-right"><b>Nombre</b>
                                    </label>
                            </div>

                            <div class="form-floating mb-3">
                                <textarea type="text" class="form-control" required="true" formControlName="descripcion"
                                maxlength="250" [ngClass]="{
                                  'is-invalid': this.formRol.get('descripcion')?.errors && this.submitted,
                                  'is-valid': !this.formRol.get('descripcion')?.errors,
                                }"></textarea>
                                <small class="invalid-feedback"
                                *ngIf="this.formRol.get('descripcion')?.errors?.['required'] && this.submitted">
                                    Campo requerido</small>


                                <label for="descripcion">Descripción</label>
                            </div>

                           <div class="form-floating mb-3">
                                <select id="estado" class="form-select" formControlName="estado" required="true" [ngClass]="{
                                    'is-invalid': this.formRol.get('estado')?.errors && this.submitted,
                                    'is-valid': !this.formRol.get('estado')?.errors,
                                  }">
                                    <option value="1" selected>Activo</option>
                                    <option value="2">Inactivo</option>
                                  </select>
                                  <label for="estado">Estado</label>
                                  <small class="invalid-feedback"
                                    *ngIf="this.formRol.get('estado')?.errors?.['required'] && this.submitted"> Campo
                                    requerido</small>
                                </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary waves-effect"
                        (click)="modal.close();">Cerrar</button>
                    <button type="button" class="btn btn-info" (click)="onSubmit()"
                        >Guardar</button>
                </div>
            </div>
        </div>
</jw-modal>
